import { HeartToggleButton } from "./heart-toggle-button";
import { SaveColorDropdown } from "./save-color-dropdown";
import { useMyLikedColorsStore } from "../../../js/stores/my-liked-colors-store";
import { useSaveColor } from "../../save-color";
import { TrendingBadge } from "../my-saved-colors/trending-badge";

export function LikedButtons({ basketAction, collectionAction }) {
  const { saveColorLabel, removeColorLabel, colorCode, isTrending } = useSaveColor();
  const isLikedStoreReady = useMyLikedColorsStore(
    (state) => state._hasHydrated
  );
  const likedColors = useMyLikedColorsStore((state) => state.likedColors);
  const addColor = useMyLikedColorsStore((state) => state.addColor);
  const removeColor = useMyLikedColorsStore((state) => state.removeColor);
  const likedColor = likedColors.find(
    (color) => color === colorCode
  );
  const isColorLiked = !!likedColor;
  const toggleClickHandler = () => {
    if (isColorLiked) {
      removeColor(colorCode);
    } else {
      addColor(colorCode);
    }
  };
  const saveAction = isLikedStoreReady
    ? {
        label: isColorLiked ? removeColorLabel : saveColorLabel,
        clickHandler: () => toggleClickHandler(),
      }
    : null;
  const actions = [basketAction, collectionAction, saveAction].filter(
    (action) => action
  );

  return (
    <div>
      {isLikedStoreReady && (
        <HeartToggleButton
          isSaved={isColorLiked}
          toggleClickHandler={toggleClickHandler}
        />
      )}
      <SaveColorDropdown actions={actions} />
      {!!isTrending && <TrendingBadge />}
    </div>
  );
}
